<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="24"
    viewBox="0 0 58 24">
    <defs>
      <filter id="kqeay8qn4a">
        <feColorMatrix
          in="SourceGraphic"
          values="1 0 0 0 0
            0 1 0 0 0
            0 0 1 0 0
            0 0 0 1 0" />
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(-20 -16) translate(20 16)">
        <path
          fill="currentColor"
          fill-rule="nonzero"
          d="M29.7 23.5h-7.85v-4.448h7.225c1.875 0 3.2-.556 3.2-2.452 0-1.845-1.3-2.376-3.2-2.376h-1.15C23.7 14.047 21 11.798 21 7.324 21 2.825 23.85.5 28.3.5H36v4.448h-7.2c-1.875 0-3.125.556-3.125 2.401 0 1.846 1.225 2.452 3.125 2.452h1.275C34.3 9.978 37 12.076 37 16.651c0 4.347-2.85 6.849-7.3 6.849zM17 15.394V.5h-5.51v14.77c0 2.088-1.186 3.307-3.015 3.307-1.828 0-2.965-1.194-2.965-3.307V.5H0v14.894C0 20.342 3.805 23.5 8.475 23.5c4.646 0 8.525-3.158 8.525-8.106zM58 15.394V.5h-5.51v14.77c0 2.088-1.186 3.307-3.015 3.307-1.828 0-2.965-1.194-2.965-3.307V.5H41v14.894c0 4.948 3.805 8.106 8.475 8.106 4.646 0 8.525-3.158 8.525-8.106z" />
      </g>
    </g>
  </svg>
</template>
